export default {"src":"/_next/static/media/product-unicorn.7cd3e20d.svg","height":360,"width":360};